import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {List} from 'immutable';

import Icon from '../icon/Icon';
import Message from '../message/Message';
import SmallSocialCard from '../small-social-card/SmallSocialCard';
import styles from './SocialCard.pcss';
import socialStyles from '../../styles/social.pcss';
import {social, socialCardType, svgs, CustomPropShapes} from '../../constants';

class SocialCard extends PureComponent {
    static propTypes = {
        title: PropTypes.string.isRequired,
        titleArgs: PropTypes.array,
        onClickConnect: PropTypes.func,
        onClickFind: PropTypes.func,
        platforms: PropTypes.instanceOf(List),
        type: CustomPropShapes.oneOfConstant(socialCardType)
    };

    static defaultProps = {
        type: socialCardType.FEED
    };

    generateIcons = () => {
        const {platforms} = this.props;

        if (platforms) {
            return platforms.map(platform => (
                <Icon
                    key={platform}
                    className={styles.icon}
                    {...social.LINK_ACCOUNT_ICONS[platform]}
                />
            ));
        }

        return <Icon className={styles.icon} icon={svgs.STRESSED_FACE} />;
    };

    renderButton = icons => {
        const {title, titleArgs, onClickConnect, onClickFind, platforms, type} = this.props;

        const message = platforms ? title : 'diesel.common.friend_status_list.no_friends_online';
        // NOTE: in the case that platforms.size === 1, ctaText will return false and hide the <Message>. This is desired behavior.
        const ctaText = platforms
            ? platforms.size > 1 && 'diesel.common.friend_status_list.connect'
            : 'diesel.common.friend_status_list.find';
        const onClick = platforms && platforms.size > 0 ? onClickConnect : onClickFind;
        return (
            <button className={styles.button} onClick={onClick}>
                <h2 className={styles.heading}>
                    {message && <Message code={message} args={titleArgs} />}
                </h2>
                <div className={styles.iconsWrapper}>{icons}</div>
                {type === socialCardType.RIGHT_RAIL && ctaText && (
                    <Message className={styles.cta} code={ctaText} />
                )}
            </button>
        );
    };

    renderMobileRightRailButton = icons => {
        const {onClickConnect, onClickFind, platforms} = this.props;
        const socialProps = platforms
            ? {
                  primaryText: 'diesel.common.friend_status_list.connect_and_find',
                  onClick: onClickConnect
              }
            : {
                  primaryText: 'diesel.common.friend_status_list.no_friends_online',
                  onClick: onClickFind
              };

        return <SmallSocialCard {...socialProps}>{icons}</SmallSocialCard>;
    };

    render() {
        const {platforms, type} = this.props;
        const isFeed = type === socialCardType.FEED;
        const icons = this.generateIcons();
        const shouldShowPlatformBg = platforms && platforms.size === 1;
        const styleType = shouldShowPlatformBg && !isFeed ? 'rightRailSingle' : type;
        const wrapperClasses = cx(styles.wrapper, styles[styleType], {
            [styles.backgroundColor]: !shouldShowPlatformBg,
            [socialStyles[platforms && `${platforms.get(0)}-bg`]]: shouldShowPlatformBg
        });

        return (
            <div className={wrapperClasses}>
                {this.renderButton(icons)}
                {!isFeed && this.renderMobileRightRailButton(icons)}
            </div>
        );
    }
}

export default SocialCard;
